import { useState, useEffect } from 'react';
import { siteInfo } from '@/mocks/home';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '热门话题', href: '#topics' },
  { label: '热度榜单', href: '#ranking' },
  { label: '精选推荐', href: '#cards' },
  { label: '特色优势', href: '#features' },
  { label: '常见问答', href: '#faq' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-100/95 backdrop-blur-md shadow-[0_1px_0_oklch(var(--background-200))]'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <a
            href="#hero"
            onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}
            className="flex items-center gap-2 no-underline"
          >
            <span className="font-heading text-2xl md:text-3xl text-primary-500 tracking-wide">
              {siteInfo.name}
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                className="px-3 py-2 text-sm text-foreground-600 hover:text-primary-400 transition-colors duration-200 rounded-md whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <button className="px-4 py-2 text-sm text-foreground-300 hover:text-foreground-600 transition-colors cursor-pointer whitespace-nowrap rounded-md">
              登录
            </button>
            <button className="px-5 py-2 text-sm bg-primary-500 text-white rounded-md hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap font-medium">
              加入我们
            </button>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-600 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-100/98 backdrop-blur-md border-t border-background-200">
          <nav className="flex flex-col px-4 py-3 gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                className="px-3 py-3 text-sm text-foreground-600 hover:text-primary-400 transition-colors rounded-md cursor-pointer"
              >
                {item.label}
              </a>
            ))}
            <div className="flex gap-3 mt-2 pt-3 border-t border-background-200">
              <button className="flex-1 px-4 py-2 text-sm text-center text-foreground-500 hover:text-foreground-600 transition-colors cursor-pointer rounded-md border border-background-300 whitespace-nowrap">
                登录
              </button>
              <button className="flex-1 px-4 py-2 text-sm text-center bg-primary-500 text-white rounded-md hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                加入我们
              </button>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}